import React from 'react';
import { PolicyLayout } from '../components/layout/PolicyLayout';
export function ReturnPolicyPage() {
  const sections = [{
    id: 'overview',
    title: 'Return Policy Overview',
    content: <>
          <p data-id="element-8792" data-mp="1two03vu0dkgv">
            At Innova Pharmacy, customer satisfaction is our priority. We
            understand that sometimes products may not meet your expectations.
            This Return Policy outlines the conditions and procedures for
            returning products purchased from our online store.
          </p>
          <p className="mt-4" data-id="element-8793" data-mp="27n17nx2zmx5o">
            Please read this policy carefully before making a purchase. By
            purchasing from Innova Pharmacy, you agree to this Return Policy.
          </p>
        </>
  }, {
    id: 'eligibility',
    title: 'Return Eligibility',
    content: <>
          <p className="mb-4" data-id="element-8794" data-mp="ic940tjftj0q">
            Products are eligible for return if they meet the following
            conditions:
          </p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8795" data-mp="1vn5doe3ot34j">
            <li data-id="element-8796" data-mp="1voqaybhdz063">
              The product is in its original, unopened, and unused condition
            </li>
            <li data-id="element-8797" data-mp="1lx2d9su8kmw6">
              The product is in its original packaging with all labels intact
            </li>
            <li data-id="element-8798" data-mp="1hvqx0dx95e0n">The return request is made within 14 days of delivery</li>
            <li data-id="element-8799" data-mp="1htnvoxqnfygm">
              The product is not on the non-returnable items list (see below)
            </li>
            <li data-id="element-8800" data-mp="29mn7x8zr58la">You have the original receipt or proof of purchase</li>
          </ul>
          <p className="mt-4" data-id="element-8801" data-mp="29ku0vsl88mcr">
            <strong data-id="element-8802" data-mp="25kjuwfxfpvxw">Important:</strong> For safety and hygiene reasons, opened
            or used products cannot be returned or exchanged.
          </p>
        </>
  }, {
    id: 'non-returnable',
    title: 'Non-Returnable Items',
    content: <>
          <p className="mb-4" data-id="element-8803" data-mp="p6tfid0v7l8y">
            The following items cannot be returned for safety, hygiene, and
            regulatory reasons:
          </p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8804" data-mp="qpa468gqxjqn">
            <li data-id="element-8805" data-mp="vmtl5g4twama">
              <strong data-id="element-8806" data-mp="vnbpz15k3x5t">Prescription Medications:</strong> All prescription drugs,
              once dispensed, cannot be returned
            </li>
            <li data-id="element-8807" data-mp="hn0zhz85skl6">
              <strong data-id="element-8808" data-mp="hpn1zkg709wj">Opened Products:</strong> Any product that has been
              opened, used, or tampered with
            </li>
            <li data-id="element-8809" data-mp="7x7lysoghvea">
              <strong data-id="element-8810" data-mp="7wph57nqa8ur">Personal Care Items:</strong> Opened personal hygiene
              products, cosmetics, and skincare items
            </li>
            <li data-id="element-8811" data-mp="cq0tfobb7hu2">
              <strong data-id="element-8812" data-mp="3u4z6x51k0el6">Medical Devices:</strong> Opened or used medical devices
              and equipment
            </li>
            <li data-id="element-8813" data-mp="2xmjw9dzp6xc">
              <strong data-id="element-8814" data-mp="2z658eei685z">Baby Formula and Food:</strong> Opened baby formula, food,
              or nutrition products
            </li>
            <li data-id="element-8815" data-mp="3l6demi6a5l77">
              <strong data-id="element-8816" data-mp="3q342hrobtl36">Vitamins and Supplements:</strong> Opened vitamin bottles
              and supplement containers
            </li>
            <li data-id="element-8817" data-mp="36idbqhmhw2a8">
              <strong data-id="element-8818" data-mp="36hu5hy67j2c1">Sale Items:</strong> Products marked as final sale or
              clearance (unless defective)
            </li>
            <li data-id="element-8819" data-mp="31kk5jol6z89y">
              <strong data-id="element-8820" data-mp="3fhqlzcig0uw0">Gift Cards:</strong> Gift cards and promotional vouchers
            </li>
          </ul>
        </>
  }, {
    id: 'process',
    title: 'Return Process',
    content: <>
          <p className="mb-4" data-id="element-8821" data-mp="3pf4sokeke5b4">
            To initiate a return, please follow these steps:
          </p>
          <ol className="list-decimal pl-6 space-y-3" data-id="element-8822" data-mp="3kg1vtn8qn5e8">
            <li data-id="element-8823" data-mp="30lpljv1icjy">
              <strong data-id="element-8824" data-mp="313iq7meoann">Submit Return Request:</strong> Log in to your account, go
              to "My Orders", select the order, and click "Request Return".
              Alternatively, contact our customer service at +966 920 000 000 or
              returns@innovapharmacy.com.
            </li>
            <li data-id="element-8825" data-mp="72p4yjkty1ai">
              <strong data-id="element-8826" data-mp="72ymrjvq1254">Provide Details:</strong> Specify the reason for return
              and upload photos if the product is damaged or defective.
            </li>
            <li data-id="element-8827" data-mp="26hi9urc1xtpk">
              <strong data-id="element-8828" data-mp="26gyr58ekv1ah">Await Approval:</strong> Our team will review your request
              within 1-2 business days and notify you of the approval status.
            </li>
            <li data-id="element-8829" data-mp="2bakycl1z2cyw">
              <strong data-id="element-8830" data-mp="2f9k6eej02puk">Return Shipping:</strong> Once approved, you can either:
              <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-8831" data-mp="2fbmwszo2ekzt">
                <li data-id="element-8832" data-mp="1il46ppm6f03q">Schedule a free pickup from your location</li>
                <li data-id="element-8833" data-mp="1ni4dk2quo6vw">Drop off the product at any of our store locations</li>
              </ul>
            </li>
            <li data-id="element-8834" data-mp="1rjy8rvia0ioo">
              <strong data-id="element-8835" data-mp="1rjg8mnshtkbh">Inspection:</strong> Upon receiving the returned product,
              we will inspect it to ensure it meets our return criteria.
            </li>
            <li data-id="element-8836" data-mp="32zwfvttw8un9">
              <strong data-id="element-8837" data-mp="32ycyfzwi4djw">Refund Processing:</strong> If approved, your refund will
              be processed within 5-7 business days.
            </li>
          </ol>
        </>
  }, {
    id: 'damaged-defective',
    title: 'Damaged or Defective Products',
    content: <>
          <p data-id="element-8838" data-mp="3d4ctegjwhznw">
            If you receive a damaged, defective, or incorrect product, please
            contact us immediately. We will arrange for a replacement or full
            refund at no additional cost to you.
          </p>
          <p className="mt-4 mb-4" data-id="element-8839" data-mp="348x3ubq6i6o4">To report a damaged or defective product:</p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8840" data-mp="2zdhrxpbqekuc">
            <li data-id="element-8841" data-mp="2ud3gdxax8srk">Contact us within 48 hours of delivery</li>
            <li data-id="element-8842" data-mp="2ubiokffzrnxe">Provide clear photos of the damaged product and packaging</li>
            <li data-id="element-8843" data-mp="2peiii4j56l6a">Keep the product and packaging until the issue is resolved</li>
          </ul>
          <p className="mt-4" data-id="element-8844" data-mp="2ld6x6b7awm3w">
            We will investigate the issue and arrange for a replacement or
            refund as quickly as possible.
          </p>
        </>
  }, {
    id: 'refunds',
    title: 'Refund Policy',
    content: <>
          <p className="mb-4" data-id="element-8845" data-mp="2d2zkcyl9bsgj">
            Once your return is approved and received, refunds will be processed
            as follows:
          </p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8846" data-mp="2hvizhzzlevng">
            <li data-id="element-8847" data-mp="243ma43pb6zur">
              <strong data-id="element-8848" data-mp="243ura7sgsrbr">Credit/Debit Card:</strong> Refunded to the original
              payment method within 5-7 business days
            </li>
            <li data-id="element-8849" data-mp="28223cpbzh4gm">
              <strong data-id="element-8850" data-mp="2vu8w7eii2tba">Cash on Delivery:</strong> Issued as store credit or bank
              transfer within 5-7 business days
            </li>
            <li data-id="element-8851" data-mp="30rso3h84f4lp">
              <strong data-id="element-8852" data-mp="30sao8oxwm2yw">Digital Wallets:</strong> Refunded to the original wallet
              within 3-5 business days
            </li>
            <li data-id="element-8853" data-mp="2rs5iskc9tend">
              <strong data-id="element-8854" data-mp="2rrmbryo5sao4">Buy Now Pay Later (Tabby/Tamara):</strong> Refund
              processed according to the provider's policy
            </li>
          </ul>
          <p className="mt-4" data-id="element-8855" data-mp="1bgicijsjpnt0">
            Please note that the original delivery fee is non-refundable unless
            the product was damaged, defective, or incorrect.
          </p>
        </>
  }, {
    id: 'exchanges',
    title: 'Exchanges',
    content: <>
          <p data-id="element-8856" data-mp="13wzbkyjcj9w5">
            We currently do not offer direct product exchanges. If you wish to
            exchange a product, please return the original item for a refund and
            place a new order for the desired product.
          </p>
          <p className="mt-4" data-id="element-8857" data-mp="p4yvtu4m8j04">
            For damaged or defective products, we will arrange a direct
            replacement without requiring you to place a new order.
          </p>
        </>
  }, {
    id: 'cancellations',
    title: 'Order Cancellations',
    content: <>
          <p className="mb-4" data-id="element-8858" data-mp="u3s85j8623yp">
            You may cancel your order before it has been shipped:
          </p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8859" data-mp="6dxvp2rrehez">
            <li data-id="element-8860" data-mp="1gfll9209w5e">Log in to your account and go to "My Orders"</li>
            <li data-id="element-8861" data-mp="1fw4tvo3ddsy">Select the order you wish to cancel</li>
            <li data-id="element-8862" data-mp="3c30kmq43ku47">Click "Cancel Order" if the option is available</li>
            <li data-id="element-8863" data-mp="3h1btaxinoyku">
              If the cancel option is not available, contact customer service
              immediately
            </li>
          </ul>
          <p className="mt-4" data-id="element-8864" data-mp="3lzlr7fvrmda5">
            Once an order has been shipped, it cannot be cancelled. You will
            need to follow the return process once you receive the product.
          </p>
        </>
  }, {
    id: 'contact-returns',
    title: 'Contact Us',
    content: <>
          <p className="mb-4" data-id="element-8865" data-mp="3syzznxgow01">
            For questions about returns or to initiate a return, please contact
            us:
          </p>
          <ul className="list-none space-y-2" data-id="element-8866" data-mp="dkbpw9zp9c3f">
            <li data-id="element-8867" data-mp="dk212pqe5azb">
              <strong data-id="element-8868" data-mp="dmo54fe2p8cs">Email:</strong> returns@innovapharmacy.com
            </li>
            <li data-id="element-8869" data-mp="il998pwg4c6i">
              <strong data-id="element-8870" data-mp="ihldrl7fxfp5">Phone:</strong> +966 920 000 000
            </li>
            <li data-id="element-8871" data-mp="mm2x5j9w1qze">
              <strong data-id="element-8872" data-mp="mljdny4lauj9">Hours:</strong> 24/7 Customer Support
            </li>
          </ul>
          <p className="mt-4" data-id="element-8873" data-mp="274vjksggqvii">
            Our customer service team is here to help make your return
            experience as smooth as possible.
          </p>
        </>
  }];
  return <PolicyLayout title="Return Policy" description="Learn about our return and refund policy. We want you to be completely satisfied with your purchase from Innova Pharmacy." lastUpdated="January 15, 2025" sections={sections} seoTitle="Return Policy - Innova Pharmacy" seoDescription="Read Innova Pharmacy's Return Policy for information on returns, refunds, exchanges, and non-returnable items. Customer satisfaction guaranteed." canonical="/return-policy" data-id="element-8874" data-mp="1y35rdkerbsjo" />;
}